<div *ngIf="!data.info && !data.alert" mat-dialog-content fxLayout="column">
  <div
    (click)="closeDialog()"
    class="closeIcon"
    fxLayout="row"
    fxLayoutAlign="end end"
  >
    <h1 class="close">X</h1>
  </div>
  <div
    *ngIf="data.icon"
    class="icon"
    fxLayout="row"
    fxLayoutAlign="center center"
  >
    <mat-icon [svgIcon]="data.icon"></mat-icon>
  </div>
  <div class="text">
    <div class="line" fxLayout="row" fxLayoutAlign="start end">
      <span *ngIf="data.line"></span>
    </div>
    <h1 *ngIf="data.timer">{{ timeToCountDown | formatTimeMmSs }}</h1>
    <h1 *ngIf="data.title" [innerHTML]="data.title"></h1>
    <h3 *ngIf="data.subtitle" [innerHTML]="data.subtitle"></h3>
  </div>
  <div
    *ngIf="data.button"
    class="button-container"
    fxLayout="column"
    fxLayoutAlign="end center"
  >
    <button
      *ngIf="data.button.type === 'timer'"
      (click)="retrySendNotifyToClient()"
      class="button-modal"
      mat-button
      color="accent"
    >
      {{ data.button.text }}
    </button>
    <button
      *ngIf="data.button.type === 'close'"
      (click)="closeDialog()"
      class="button-modal"
      mat-button
      color="accent"
    >
      {{ data.button.text }}
    </button>
  </div>
</div>

<!-- Panel Popup Info -->
<div *ngIf="data.info" mat-dialog-content fxLayout="column">
  <div
    *ngIf="data.closeIcon"
    (click)="closeDialog()"
    class="closeIcon"
    fxLayout="row"
    fxLayoutAlign="end end"
  >
    <h1 class="close">X</h1>
  </div>
  <div class="text">
    <p class="titleInfo" *ngIf="data.title" [innerHTML]="data.title"></p>
    <div *ngIf="data.content">
      <div
        class="coverage-detail"
        fxLayout="row"
        *ngFor="let detalle of data.content"
      >
        <mat-icon
          class="icon"
          *ngIf="detalle.imagen"
          [svgIcon]="detalle.imagen"
        ></mat-icon>
        <p [innerHTML]="detalle.descPantallaSeccion"></p>
      </div>
    </div>
  </div>
</div>

<!-- Panel Popup Alert -->
<div *ngIf="data.alert" mat-dialog-content fxLayout="column">
  <div class="text">
    <h1 class="alert-title">{{data.title}}</h1>
    <div *ngIf="data.content">
      <p class="alert-text">{{data.content}}</p>
    </div>
  </div>

  <div class="button-container">
    <button (click)="closeDialog()">Continuar</button>
  </div>
</div>
